export default class ReceiptPaymentModel {
  public Date: string;
  public DateNum: number;
  public Amount: number;
  public ReceiptId: string;
  public DateStr: string;
}
